import React from 'react';
import { DashboardWidget } from './DashboardWidget';
import { TableWidget, TableRow } from './TableWidget';

interface BalancesWidgetProps {
  title: string;
  rows: TableRow[];
  loading: boolean;
  error: string | null;
  refreshing: boolean;
  onRefresh: () => void;
  lastUpdated?: Date;
  className?: string;
  titleIcon?: React.ReactNode; // Optional icon to display next to title
}

export const BalancesWidget: React.FC<BalancesWidgetProps> = ({
  title,
  rows,
  loading,
  error,
  refreshing,
  onRefresh,
  lastUpdated,
  className,
  titleIcon
}) => {
  // Loading state UI
  if (loading) {
    return (
      <div className={`dashboard-widget token-values ${className}`}>
        <div className="widget-header">
          <h3 className="widget-title">
            {title}
            {titleIcon}
          </h3>
        </div>
        <div className="widget-content">
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Loading your balances...</p>
          </div>
        </div>
        <div className="widget-refresh-bottom">
          <button 
            className="refresh-button"
            disabled={true}
            style={{ pointerEvents: 'none' }}
          >
            Refresh
          </button>
          {lastUpdated && (
            <span className="last-updated">
              Last updated:<br/>{lastUpdated.toLocaleTimeString()}
            </span>
          )}
        </div>
      </div>
    );
  }

  // Normal rendering with DashboardWidget
  return (
    <DashboardWidget
      title={title}
      titleIcon={titleIcon}
      loading={false}
      error={error || undefined}
      className={`token-values ${className}`}
      onRefresh={loading ? undefined : onRefresh}
      refreshing={refreshing || loading}
      lastUpdated={lastUpdated}
      refreshButtonBottom={true}
    >
      <TableWidget
        rows={rows}
        showLabelColumn={false}
        columnHeaders={{
          token: 'Token',
          amount: 'Amount',
          value: 'Value'
        }}
      />
    </DashboardWidget>
  );
};
